module.exports = __webpack_public_path__ + "img/no-needCalendar.47037a1a.svg";